import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsLibrarythingComponent } from './simple-icons-librarything.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsLibrarythingComponent ],
    exports:      [ SimpleIconsLibrarythingComponent ],
    bootstrap:    []
})
export class SimpleIconsLibrarythingModule {}
